import { defineComponent as _defineComponent } from 'vue'
import { computed, useAttrs } from "vue"
import { VTextField } from "vuetify/lib"


export default /*#__PURE__*/_defineComponent({
  __name: 'OutlinedTextField',
  props: {
    label: null,
    required: { type: Boolean },
    labelEndAdornment: null
  },
  setup(__props: any) {



const attrs = computed(() => {
  const { label, prependIcon, ...rest } = useAttrs()
  return rest
})

return { __sfc: true,attrs, VTextField }
}

})